import { getCustomRowCellAlignClass } from 'public/components/kye-table2/config/columns.js'
import { createCellOption } from 'public/components/kye-table2/components/body/cell-option'
import { createHeaderCellOptions } from 'public/components/kye-table2/components/header/header-thead/cell-options.js'
import Router from '@/layout/router'
import { getValue } from 'public/components/kye-canvas-table/utils.js'
import { WIDGET_PREFIEX } from '../plugins/auto-widget'

// 这里的数据仅在column中，不会更新store.visibleFlatColumns。导致在 拖拽列宽的时候 会导致更新的时候 用的还是最开始的值。所以该功能仅在此处的内存和本地缓存使用

const CellOption = createCellOption()
const HeaderCellOption = createHeaderCellOptions()

let levelCache = {}

let defaultLevel = -3

const cachePrefix = 'CanvasTextFlex'

function initCache() {
  let cache = localStorage.getItem(cachePrefix)
  if (cache) {
    levelCache = JSON.parse(cache)
  }
  // console.log('init', levelCache)
}

initCache()

function getCacheKey (key, col) {
  if (levelCache[key] === 0) {
    return 0
  }
  if (levelCache.hasOwnProperty(key) && typeof levelCache[key] === 'number') {
    return levelCache[key]
  }
  const hasTextFlexCurrentLevel = typeof col.TextFlexCurrentLevel === 'number'
  const TextFlexCurrentLevel = col.TextFlexCurrentLevel
  const defaultTextFlexLevel = col.defaultTextFlexLevel
  if (col && typeof defaultTextFlexLevel === 'number') {
    return defaultTextFlexLevel >= 0 ? 0 : (hasTextFlexCurrentLevel && defaultTextFlexLevel <= TextFlexCurrentLevel ? TextFlexCurrentLevel : defaultTextFlexLevel)
  }
  return hasTextFlexCurrentLevel ? (defaultLevel <= TextFlexCurrentLevel ? TextFlexCurrentLevel : defaultLevel) : defaultLevel
}




// 缩进的公共方法

export function extractMaxLevelFromRowData(data, col) {
  let key = col.key
  let delimiter = col.delimiter || '/'
  if (!data || data.length === 0) return 0
  try {
    let levels = data.map(function(row) {
      let value = getValue(key, row)
      // 如果九级组织字段最后一个是以/结尾，则去除
      if (value && value[value.length - 1] === '/') {
        value = value.substr(0, value.length - 1)
      }
      return value ? value.split(delimiter).length : 0
    })
    return Math.max(...levels)
  } catch (e) {
    return 0
  }
}

export function subPlusDeptIndet (type, oldLevel, cacheKey, textFlexWidgetMapItem) {
  const { TextFlexMaxLevel } = textFlexWidgetMapItem || {}
  let level
  if (type === '-') {
    // 缩进
    level = oldLevel - 1
    if (Math.abs(oldLevel) >= TextFlexMaxLevel) {
      level = -TextFlexMaxLevel + 1
    }
  } else if (type === '+') {
    // 复原
    level = oldLevel + 1
    if (oldLevel >= TextFlexMaxLevel) {
      level = TextFlexMaxLevel - 1
    }
  }
  levelCache[cacheKey] = level
}

export function setDeptIndent (col, val) {
  let cacheKey = makeKey(col)
  if (typeof val === 'number') {
    levelCache[cacheKey] = val
    col.TextFlexCurrentLevel = val
  }
  console.log('当前缩进::::', levelCache[cacheKey])
  setLocalStorage()
}


export function deptIndent (type, col, vm) {
  let cacheKey = makeKey(col)
  const textFlexWidgetMapItem = vm.textFlexWidgetMap[col.key]
  let oldLevel = textFlexWidgetMapItem.TextFlexCurrentLevel
  oldLevel = getCacheKey(cacheKey, col)
  subPlusDeptIndet(type, oldLevel, cacheKey, textFlexWidgetMapItem)
  setLocalStorage()
  vm.setTextFlexWidgetCurrentLevel(col.key, levelCache[cacheKey])
  console.log('当前缩进::::', levelCache[cacheKey])
}

function format (col, val, vm) {
  // 九级组织字段如果是空则返回空字符串
  if (!val) {
    return ''
  }
  const { TextFlexCurrentLevel } = vm.textFlexWidgetMap[col.key] || {}
  let cacheKey = makeKey(col)
  let delimiter = col.delimiter || '/'
  let level = TextFlexCurrentLevel // 为了触摸get.更新视图
  level = getCacheKey(cacheKey, col)
  if (!level && level !== 0) {
    level = 0
    levelCache[cacheKey] = 0
    vm.setTextFlexWidgetCurrentLevel(col.key, 0)
  }
  try {
    if (level >= 0) {
      return val
    } else {
      // 九级组织字段是否以/结尾
      let temp = val[val.length - 1] === '/'
      let arr = val.split(delimiter)
      if (temp) {
        arr.pop()
      }
      let currentLevel = arr.length > Math.abs(level) ? Math.abs(level) : arr.length - 1
      arr.splice(0, currentLevel)
      return temp ? arr.join(delimiter) + '/' : arr.join(delimiter)
    }
  } catch (e) {
    console.error('[TextFlexWidget format]: ', e)
    return val
  }
}

export function getTextFlexCurrentLevel(col) {
  let cacheKey = makeKey(col)
  let oldLevel = getCacheKey(cacheKey, col)
  return oldLevel
}

function setLocalStorage () {
  localStorage.setItem(cachePrefix, JSON.stringify(levelCache))
}

function makeKey (col) {
  const path = Router.currentRoute.path
  return path + col.key
}

export function createTextFlexColumnConfig (col, data, drawOption, options) {
  const { vm } = options
  const useTextFlexWidget = col.textFlexWidget === true
  if (useTextFlexWidget) {
    vm.setTextFlexWidgetMap(col, vm.data)
    return {
      labelClassName: TEXT_FLEX_CLASS,
      headerCellRender: (h, props) => {
        return createTextFlexHeaderCellRender(h, props, vm)
      },
      rowCellRender: (h, cellParams) => createTextFlexRowCellRender(h, cellParams, drawOption, vm),
    }
  }
  return null
}


const TEXT_FLEX_CLASS = ' table2-warp-custom-text-flex'
const getWarpClass = (suffix) => TEXT_FLEX_CLASS + suffix

export function getTextFlexDisabled (vm, column) {
  const { TextFlexCurrentLevel, TextFlexMaxLevel } = vm.textFlexWidgetMap[column.key] || {}
  let oldLevel = TextFlexCurrentLevel // 为了触摸get.更新视图
  let cacheKey = makeKey(column)
  oldLevel = getCacheKey(cacheKey, column)
  let maxLevel = TextFlexMaxLevel

  let canSub = true
  let canPlus = true
  if (!maxLevel) {
    canSub = false
    canPlus = false
  } else {
    maxLevel = ~maxLevel + 2 // eg: 5 => -4; 9 => -8
    if (oldLevel <= maxLevel) {
      canSub = false
    }
    if (oldLevel >= 0) {
      canPlus = false
    }
  }
  return {
    canSub,
    canPlus
  }
}

/* 渲染的方法 */
export function createTextFlexHeaderCellRender (h, props, vm) {
  const { rowIndex, columnIndex, handleEvent, column } = props
  const { placeholderSign, label } = column
  const classes = [getWarpClass(`-header`)]

  const iconCommonClasses = ['layout', getWarpClass('-icon')]
  const sub = getWarpClass('-sub')
  const plus = getWarpClass('-plus')
  const disabled = getWarpClass('-icon-gray')

  const iconSubClasses = [...iconCommonClasses, sub, getWarpClass('-icon-left')]
  const iconPlusClasses = [...iconCommonClasses, plus, getWarpClass('-icon-right')]

  const {
    canPlus,
    canSub
  } = getTextFlexDisabled(vm, column)
  if (!canSub) {
    iconSubClasses.push(...[disabled, getWarpClass('-sub-gray')])
  }
  if (!canPlus) {
    iconPlusClasses.push(...[disabled, getWarpClass('-plus-gray')])
  }
  const mouseenter = (event) => {
    column._isForce = column.showOverflowTooltipOnHeader === false ? false : props.store.table.showOverflowTooltipOnHeader
    handleEvent && handleEvent(event, { column, eventType: 'label-mouse-enter', rowIndex, columnIndex, event })
  }
  const mouseleave = (event) => {
    handleEvent && handleEvent(event, { column, eventType: 'label-mouse-leave', rowIndex, columnIndex, event })
  }
  return [
    <span on-mouseenter={mouseenter} on-mouseleave={mouseleave}>{placeholderSign ? '' : label}</span>,
    <div class={classes}>
    <i
      class={iconSubClasses}
      on-click={(event) => {
        event.stopPropagation()
        if (!canSub) {
          return
        }
        deptIndent('-', column, vm)
      }}
    ></i>
    <i
      class={iconPlusClasses}
      on-click={(event) => {
        event.stopPropagation()
        if (!canPlus) {
          return
        }
        deptIndent('+', column, vm)
      }}
    ></i>
    <HeaderCellOption {...{props}}></HeaderCellOption>
  </div>
  ]
}

export function createTextFlexRowCellRender (h, cellParams, drawOption, vm) {
  const { column, value, rowData } = cellParams
  const alignClass = getCustomRowCellAlignClass(column)
  const classes = [...alignClass, getWarpClass(`-row-cell`)]

  const text = format(column, value, vm)

  rowData[WIDGET_PREFIEX + column.key] = text

  const customRowCellRender = drawOption && drawOption.rowCellRender

  const _cellParams = Object.assign({}, cellParams, {value: text})
  return customRowCellRender ? customRowCellRender(h, _cellParams) : <div class={classes}>
    <CellOption {...{props: _cellParams}}></CellOption>
  </div>
}

export default {
  createTextFlexHeaderCellRender,
  createTextFlexRowCellRender,
  labelClassName: TEXT_FLEX_CLASS,
  format,
  extractMaxLevelFromRowData,
  getTextFlexCurrentLevel,
  deptIndent,
  getTextFlexDisabled
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/feature/text-flex-render.js